import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const DeleteClassOfferingMutation = graphql.persisted(
  "DeleteClassOffering",
  graphql(`
    mutation DeleteClassOffering($input: DeleteClassOfferingInput!) {
      deleteClassOffering(input: $input) {
        success
        userErrors {
          message
          path
          code
        }
      }
    }
  `)
);

export { DeleteClassOfferingMutation };

export function useDeleteClassOffering() {
  return useMutation(DeleteClassOfferingMutation);
}
